import {
    GET_ALL_AUCTIONS,
    GET_SINGLE_AUCTION,
    GET_AUCTION_PROJECTS,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_AUCTION_RESULT,
    GET_ALL_REGISTERED_USER,
    GET_ALL_PERSON_AUCTION_STATISTICS,
} from './auctionTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_AUCTIONS:
            return {
                ...state,
                all_auctions: action.payload,
            }
        case GET_SINGLE_AUCTION:
            return {
                ...state,
                single_auction: action.payload,
            }
        case GET_AUCTION_RESULT:
            return {
                ...state,
                auction_result: action.payload,
            }
        case GET_AUCTION_PROJECTS:
            return {
                ...state,
                auction_projects: action.payload,
            }
        case GET_ALL_REGISTERED_USER:
            return {
                ...state,
                all_registered_auction: action.payload,
            }
        case GET_ALL_PERSON_AUCTION_STATISTICS:
            return {
                ...state,
                in_person_statistics: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
